import React from 'react';
import cPanelImage from 'assets/images/cpanel.svg';
import { Trans } from 'react-i18next';
import { NewVMStep3SC, StepDescription, Image, Description } from './BmCartStep3.style';
import Heading from 'components/Heading/Heading';
import { P } from 'components/reusable-css';
import CPanel from 'pages/shoping-cart/component/cPanel-card/CPanelCard';

const BmCartStep3 = ({ appsData, formikProp }) => {
  return (
    <NewVMStep3SC id="ST3">
      <Heading name="public/checkout/bm.step3_string1">
        <StepDescription>
          <Image>
            <img src={cPanelImage} alt="cpanel logo" width="90%" />
          </Image>
          <Description>
            <P>
              <Trans
                i18nKey="public/checkout/bm.step3_string2"
                values={{
                  currency: 'USD',
                  currency_symbol: '$',
                }}
              >
                <a href={appsData?.bm_apps[0]?.infopage} rel="noreferrer" target="_blank" />
                <span style={{ textTransform: 'uppercase' }} />
              </Trans>
            </P>
          </Description>
        </StepDescription>
        <CPanel appData={appsData?.bm_apps[0] || []} formikProp={formikProp} />
      </Heading>
    </NewVMStep3SC>
  );
};
export default BmCartStep3;
